import { Button } from '@/components/ui/button';

interface CoverageErrorStateProps {
  onRetry: () => void;
  message?: string;
}

export const CoverageErrorState = ({
  onRetry,
  message = 'Error loading coverages',
}: CoverageErrorStateProps) => {
  return (
    <div className="text-center py-12">
      <p className="text-red-600">{message}</p>
      <Button variant="outline" size="sm" onClick={onRetry} className="mt-4">
        Try Again
      </Button>
    </div>
  );
};
